import { tokens } from "@fluentui/react-components";
import { ResponsiveBreakpoints, ScrollBarBorderRadius, ScrollBarHeight, ScrollBarWidth } from "../constants/StyleConstants";
/**
 * Flex mixin for elements
 * @param direction flex-direction
 * @param wrap flex-wrap
 * @returns GriffelStyle object
 */ export const flexParent = (direction = "row", wrap = "nowrap")=>({
        display: "flex",
        flexDirection: direction,
        flexWrap: wrap
    });
/**
 * For centering all children along cross axis in an element.
 * Requires calling flex-parent before use.
 */ export const flexParentCenterCrossAxis = {
    alignItems: "center"
};
/**
 * For Styling Button as a div
 * @returns GriffelStyle object
 */ export const styleButtonAsDiv = {
    display: "flex",
    backgroundColor: "transparent",
    border: "none",
    justifyContent: "inherit",
    textAlign: "inherit",
    color: "inherit",
    boxSizing: "inherit",
    padding: "0px",
    margin: "0px",
    font: "inherit"
};
/**
 * Truncation for text that commonly overflows.
 * @param overflow - "clip" or "ellipsis" to control text overflow behavior
 * @returns GriffelStyle object
 */ export const textClip = (overflow = "clip")=>({
        textOverflow: overflow,
        overflow: "hidden",
        whiteSpace: "nowrap"
    });
/**
 * Truncation for long text that overflows
 * @param lineNumber max number of lines to display before truncation
 */ export const previewOverflowEllipsis = (lineNumber = "5")=>({
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": lineNumber,
        whiteSpace: "pre-line",
        overflow: "hidden",
        textOverflow: "ellipsis"
    });
// Flex - Used for flexible views only
// - Applies only to elements using .flex-parent(...)
export const flexChildSizeFlexible = (width = "0px")=>({
        "-webkit-flex": `1 1 ${width}`,
        "-moz-flex": `1 1 ${width}`,
        "-ms-flex": `1 1 ${width}`,
        flex: `1 1 ${width}`,
        minHeight: 0,
        /* Chrome fix - Chrome incorrectly sets a min-height it will not go lower than */ minWidth: 0
    });
// Flex - Used for fixed sized elements
// - Applies only to elements using .flex-parent(...)
export const flexChildSizeFixed = (width = "auto")=>({
        "-webkit-flex": `0 0 ${width}`,
        "-moz-flex": `0 0 ${width}`,
        "-ms-flex": `0 0 ${width}`,
        flex: `0 0 ${width}`,
        minHeight: 0,
        /* Chrome fix - Chrome incorrectly sets a min-height it will not go lower than */ minWidth: 0
    });
/**
 * For centering all children in an element.
 * Requires calling flex-parent before use.
 */ export const flexParentCenterAll = {
    justifyContent: "center",
    alignItems: "center"
};
/**
 * Styles for scrollbar using Fluent UI v9 tokens
 */ export const styleScrollbar = {
    "::-webkit-scrollbar": {
        width: ScrollBarWidth,
        height: ScrollBarHeight
    },
    "::-webkit-scrollbar-track": {
        borderRadius: ScrollBarBorderRadius
    },
    "::-webkit-scrollbar-track-piece": {
        borderRadius: ScrollBarBorderRadius
    },
    "::-webkit-scrollbar-thumb": {
        backgroundColor: tokens.colorNeutralStroke2,
        borderRadius: ScrollBarBorderRadius
    },
    "::-webkit-scrollbar-corner": {
        backgroundColor: "transparent"
    }
};
/** The AI flair gradient for Planner */ export const PlannerFlairGradient = "linear-gradient(222deg, #A0E4FC 12.5%, #DBA9F6 86.88%)";
/** Uno Z Layers used for layering elements */ const zLayers = {
    taskEditorFullMode: 10,
    fab: 50,
    devTools: 1000,
    copilotSidecar: 1001
};
/**
 * Get uno z index layer
 * @param layer
 */ export function getZIndex(layer) {
    return zLayers[layer];
}
/**
 * Helper function to apply custom CSS at a specific breakpoint
 * @param breakpoint - The breakpoint at which to apply the styles
 * @param styles - The CSS properties to apply at the breakpoint
 * @returns GriffelStyle object with media query
 *
 * @example
 * ```typescript
 * myElement: {
 *     fontSize: tokens.fontSizeBase300,
 *     padding: tokens.spacingHorizontalL,
 *     ...responsiveBreakpoint("small", {
 *         fontSize: tokens.fontSizeBase200,
 *         padding: tokens.spacingHorizontalM,
 *     }),
 * }
 * ```
 */ export const responsiveBreakpoint = (breakpoint, styles)=>({
        [`@media ${ResponsiveBreakpoints[breakpoint]}`]: styles
    });
